import clsx from 'clsx';

import { buttonShapeClass, toolbarControlClass } from '@/shared/ui/formClasses';

/** Il campo di ricerca di una toolbar; `className` aggiunge spazio per l'icona (`pl-8`). */
export function toolbarSearchInputClass(className: string) {
  return clsx(toolbarControlClass, className);
}

const IDLE =
  'border-default bg-default text-muted not-disabled:hover:border-hover not-disabled:hover:bg-muted not-disabled:hover:text-strong';

// Un filtro con una scelta ha bordo e testo del brand, come la scheda attiva.
const ACTIVE = 'border-brand bg-default text-brand';

/** Il pulsante di un filtro: secondario finché non c'è una scelta, poi nel colore del brand. */
export function filterTriggerClass({ active = false }: { active?: boolean } = {}) {
  return clsx(buttonShapeClass, 'border px-3', active ? ACTIVE : IDLE);
}

/** Il pulsante di un filtro a due righe (etichetta sopra, valore sotto) a tutta larghezza. */
export function filterFieldTriggerClass({ active }: { active: boolean }) {
  return clsx(
    'flex w-full min-w-0 flex-col gap-0.5 rounded-lg border px-3 py-2 text-left transition-colors duration-150 focus-visible:focus-ring disabled:cursor-not-allowed disabled:opacity-60',
    active ? ACTIVE : IDLE
  );
}

/** L'etichetta di un campo di filtro, sopra il campo o dentro il suo pulsante. */
export const filterFieldLabelClass = 'block text-field-label text-subtle';

/** La voce scelta di un filtro: testo del brand, la casella o la spunta dicono la scelta. */
export const filterItemSelectedClass = 'data-[state=checked]:text-brand';
